import React, { useContext } from 'react';
import { LanguageContext } from '../../context/LanguageContextProvider';
import { VBHeight_Overview, VBWidth_Overview } from '../../common/svg';
import { MasterContext } from '../../context/MasterContextProvider';
import StationClicks from './svg/StationClicks';
import { TransitsContext } from '../../context/TransitsContextProvider';
import TrainsOverview from './svg/TrainsOverview';
import { FliterContext } from '../../context/FliterContextProvider';
import SvgOverviewFrame from '../atoms/svg/map/OverviewFrame';
import SvgOverviewObjJa from '../atoms/svg/map/OverviewObjJa';
import SvgOverviewObjEn from '../atoms/svg/map/OverviewObjEn';

const DISP_NO_SCALE = 4.5; //車号を表示するズーム倍率

type Props = {
  zoomScale: number;
};

const OverviewMap: React.FC<Props> = (props) => {
  const { zoomScale } = props;
  const { language } = useContext(LanguageContext);
  const { master } = useContext(MasterContext);
  const { transits } = useContext(TransitsContext);
  const { filter } = useContext(FliterContext);

  return (
    <svg
      width={'100%'}
      height={'100%'}
      viewBox={`0 0 ${VBWidth_Overview} ${VBHeight_Overview}`}
      preserveAspectRatio='xMidYMid meet'
      textRendering='geometricPrecision' //モーダル表示後等にテキストがずれる事象の対策
    >
      <SvgOverviewFrame></SvgOverviewFrame>
      {language === 'ja' ? (
        <SvgOverviewObjJa></SvgOverviewObjJa>
      ) : (
        <SvgOverviewObjEn></SvgOverviewObjEn>
      )}

      {/* 動的に追加する要素 */}
      <TrainsOverview
        icons={
          filter === 'LowFloor'
            ? transits.icons_overview_low_floor
            : transits.icons_overview
        }
        dispNo={zoomScale >= DISP_NO_SCALE}
      ></TrainsOverview>
      <StationClicks stations={master.stations}></StationClicks>
    </svg>
  );
};

export default React.memo(OverviewMap);
